import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="container mx-auto px-4 md:px-6 max-w-4xl py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Torna alla Home
          </Button>
        </Link>

        <h1 className="text-4xl font-extrabold mb-8">Termini di Servizio</h1>

        <div className="prose prose-gray max-w-none space-y-6">
          <p className="text-gray-600">
            <strong>Ultimo aggiornamento:</strong> 28 Dicembre 2025
          </p>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">1. Accettazione dei Termini</h2>
            <p>
              Utilizzando il servizio di e-commerce di <strong>Civaie - Di Lelmi Luciana</strong>, 
              accetti di essere vincolato ai presenti Termini di Servizio. 
              Se non accetti questi termini, ti preghiamo di non utilizzare il servizio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">2. Descrizione del Servizio</h2>
            <p>
              Civaie offre un servizio di vendita online di prodotti per animali domestici e piantine da orto. 
              Il servizio include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Catalogo prodotti online</li>
              <li>Sistema di ordini e pagamenti</li>
              <li>Opzioni di ritiro in negozio o consegna a domicilio</li>
              <li>Gestione account cliente</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">3. Registrazione Account</h2>
            <p>
              Per effettuare ordini è necessario registrare un account fornendo informazioni veritiere e aggiornate. 
              Sei responsabile della sicurezza del tuo account e della riservatezza della tua password.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">4. Ordini e Pagamenti</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Tutti i prezzi sono espressi in Euro (€) e includono IVA</li>
              <li>Accettiamo pagamenti tramite PayPal, bonifico bancario o pagamento al ritiro/consegna</li>
              <li>Gli ordini sono soggetti a disponibilità dei prodotti</li>
              <li>Ci riserviamo il diritto di rifiutare o annullare ordini in caso di errori o indisponibilità</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">5. Consegna e Ritiro</h2>
            <p><strong>Ritiro in negozio:</strong></p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Disponibile durante gli orari di apertura</li>
              <li>Riceverai notifica quando l'ordine è pronto</li>
            </ul>
            <p className="mt-4"><strong>Consegna a domicilio:</strong></p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Disponibile un giorno alla settimana</li>
              <li>Zone di consegna limitate</li>
              <li>Tempi di consegna comunicati al momento dell'ordine</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">6. Diritto di Recesso</h2>
            <p>
              In conformità al Codice del Consumo, hai diritto di recedere dall'acquisto entro 14 giorni 
              dalla ricezione del prodotto, senza necessità di fornire motivazioni.
            </p>
            <p className="mt-2">
              <strong>Eccezioni:</strong> Il diritto di recesso non si applica a prodotti deperibili 
              (piante, prodotti alimentari per animali aperti).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">7. Garanzie e Resi</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>I prodotti sono coperti dalla garanzia legale di conformità di 2 anni</li>
              <li>Per difetti o non conformità, contattaci entro 2 mesi dalla scoperta</li>
              <li>I prodotti devono essere restituiti integri e nella confezione originale</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">8. Proprietà Intellettuale</h2>
            <p>
              Tutti i contenuti del sito (testi, immagini, logo, grafica) sono di proprietà di Civaie 
              o utilizzati con licenza. È vietata la riproduzione non autorizzata.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">9. Limitazione di Responsabilità</h2>
            <p>
              Civaie non è responsabile per:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Interruzioni del servizio per manutenzione o cause di forza maggiore</li>
              <li>Danni indiretti derivanti dall'uso dei prodotti</li>
              <li>Errori nei contenuti, salvo correzione tempestiva</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">10. Modifiche ai Termini</h2>
            <p>
              Ci riserviamo il diritto di modificare questi Termini di Servizio in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina e avranno effetto immediato.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">11. Legge Applicabile</h2>
            <p>
              Questi Termini di Servizio sono regolati dalla legge italiana. 
              Per qualsiasi controversia è competente il foro del luogo di residenza del consumatore.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">12. Contatti</h2>
            <p>
              Per qualsiasi domanda o richiesta relativa ai presenti Termini di Servizio, 
              puoi contattarci presso il nostro negozio o tramite i contatti disponibili sul sito.
            </p>
          </section>
        </div>
      </div>

      <footer className="bg-gray-900 text-white py-12 mt-16">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl text-center">
          <p className="text-lg font-semibold mb-2">Civaie - Di Lelmi Luciana</p>
          <p className="text-gray-400 text-sm">40 anni di attività</p>
        </div>
      </footer>
    </div>
  );
}